// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"56":"45ff9cb6","160":"3db3a58f","184":"d049eac6","312":"cc0420cc","324":"aee2dbc0","360":"0e09a50f","592":"30d59105","896":"ea92cc8d","920":"44a97dc6"}[chunkId] + ".chunk.js";
};